import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-banners',
    template: require('./banners.component.html'),
    styles: []
})
export class BannersComponent implements OnInit {
    api: any;
    busy: Subscription;
    defaultColDefine;
    BannerList: any = [];
    private gridColumnApi;
    private columnDefs;
    private rowData;
    private rowHeight;
    static parameters = [Router, HttpClient];
    constructor(private router: Router, private http: HttpClient) {
        let parent = this;
        this.columnDefs = [
            {
                headerName: 'Action', field: 'action', width : 100 , pinned: 'left', cellRenderer: function (params) {

                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
                        <a class="editBtn" href="javascript: void(0)"><i class="icon-edit"></i></a>
                    `;
                    var editButton = eDiv.querySelectorAll('.editBtn')[0];
                    editButton.addEventListener('click', function () {
                        parent.router.navigate(['/addbanner'], { queryParams: { id: params.data.Banners_ID } });
                        //self.router.navigate(['/arealistmaster'], { queryParams: { id: params.data.HQID } });
                    });
                    return eDiv
                }
            },
            { headerName: 'Title', field: 'Banner_Title' },
            { headerName: 'Description', field: 'description',width : 350 },
            // { headerName: 'Type', field: 'BannerApplicable' },
            { headerName: 'Status', field: 'status' },
        ];
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    ngOnInit() {
        this.GetBannerDetails();
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
      }

      onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'Banner_Master' });
      }

    onGridReady(params) {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    GetBannerDetails() {
        this.busy = this.http.post('/api/admin/GetBannerDetails',{ "ID": "-1" }).subscribe((res: any) => {
            console.log(res);
            this.BannerList = res.data;
        });
    }
}
